import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import classNames from 'classnames'
import { QRCodeSVG } from 'qrcode.react'
import moment from 'moment'

import Button from 'shared/components/Button'
import IconButton from 'shared/components/IconButton'
import { pixQrCodeDataSelector } from 'credit-cards/selectors'
import { setPixQRCodeData } from 'credit-cards/actions'

import PixModal from './PixModal'
import Timer from './Timer'

import styles from './styles.module.scss'

const instructionList = [
    <T>pix.payment.instruction.step.one</T>,
    <T>pix.payment.instruction.step.two</T>,
    <T>pix.payment.instruction.step.three</T>,
    <T>pix.payment.instruction.step.four</T>,
]

const Pix = () => {
    const dispatch = useDispatch()
    const history = useHistory()

    const qrCodeData = useSelector(pixQrCodeDataSelector)
    const timeSlot = qrCodeData && moment(qrCodeData.expirationDate).diff(moment(qrCodeData.creationDate))

    const [modalOpen, setModalOpen] = useState(false)
    const [timeLeft, setTimeLeft] = useState(timeSlot)
    const [isTooltipVisible, setTooltipVisible] = useState(false)
    const [tooltipText, setTooltipText] = useState(null)
    const [cancelModalOpen, setCancelModalOpen] = useState(false)

    const onClose = () => (cancelModalOpen ? setCancelModalOpen(false) : setModalOpen(false))

    const onCancelPayment = () => {
        dispatch(setPixQRCodeData(null))
        setCancelModalOpen(true)
    }

    const onGoBackClick = () => {
        setCancelModalOpen(false)
        history.goBack()
    }

    const onConfirmModalClick = () => {
        setModalOpen(false)
        history.push(qrCodeData.redirectUrl || '/dashboard/transactions')
        dispatch(setPixQRCodeData(null))
    }

    const onCloseTooltip = e => {
        e.stopPropagation()
        setTooltipText(null)
        setTooltipVisible(false)
    }

    const handleCopyQRCode = async () => {
        try {
            await navigator.clipboard.writeText(qrCodeData?.qRCode)
            setTooltipText(<T>pix.payment.copy.qr.code.success</T>)
        } catch (err) {
            setTooltipText(<T>pix.payment.copy.qr.code.failed</T>)
        }
        setTooltipVisible(true)
    }

    return (
        <div className={styles.pixPayment}>
            <section className={classNames('container', styles.pixPaymentSection)}>
                <h1 className={styles.pixPaymentSectionTitle}>
                    <T>pix.payment.instruction.title</T>
                </h1>
                <ol className={styles.pixPaymentInstructionList}>
                    {instructionList.map((instruction, index) => (
                        <li key={index} className={styles.pixPaymentInstructionListItem}>
                            {instruction}
                        </li>
                    ))}
                </ol>
                <div className="d-flex flex-column align-items-center">
                    <div className={styles.qrCodeWrap}>
                        <QRCodeSVG value={qrCodeData?.qRCode} size={240} />
                    </div>
                    <IconButton
                        className={classNames('flex-row brand-button--outline', styles.copyButton)}
                        icon={'copy-code'}
                        label={<T>pix.payment.copy.qr.code</T>}
                        isTooltipVisible={isTooltipVisible}
                        tooltipText={tooltipText}
                        tooltipClassName={styles.tooltipPix}
                        onClick={handleCopyQRCode}
                        labelLeft
                        onCloseTooltip={e => onCloseTooltip(e)}
                    />
                </div>
                <Timer timeLeft={timeLeft} setTimeLeft={setTimeLeft} />
                <div className={styles.bottomButtonsWrap}>
                    <Button className="mr-3" btnStyle="outline" onClick={onCancelPayment}>
                        <T>pix.payment.cancel.btn.label</T>
                    </Button>
                    <Button className="mr-0" onClick={() => setModalOpen(true)}>
                        <T>pix.payment.confirm.btn.label</T>
                    </Button>
                </div>
                {(modalOpen || cancelModalOpen) && (
                    <PixModal
                        onClose={onClose}
                        onCancelClick={onClose}
                        onConfirmClick={modalOpen ? onConfirmModalClick : onGoBackClick}
                        cancelModalOpen={cancelModalOpen}
                    />
                )}
            </section>
        </div>
    )
}

export default withTranslate(Pix)
